module.exports = __webpack_public_path__ + "static/media/mars.99b252cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/mars.png
// module id = 484
// module chunks = 0